import type { AxiosResponse } from 'axios';

import axiosInstance from '../../instance';
import ROUTES from '../../routes';
import type { LoginBody, LoginResponse, OtpLoginBody, tokenData } from './types';

export const login = (data: LoginBody | OtpLoginBody): Promise<void | AxiosResponse<LoginResponse>> => axiosInstance({
  url: ROUTES.LOGIN,
  data,
  method: 'POST',
});

export const logout = (data: Pick<tokenData, 'rt'>): Promise<void | AxiosResponse> => axiosInstance({
  url: ROUTES.LOGOUT,
  data,
  method: 'POST',
});

export const refresh = (data: Pick<tokenData, 'rt'>): Promise<void | AxiosResponse<tokenData>> => axiosInstance({
  url: ROUTES.REFRESH,
  data,
  method: 'POST',
});

